// extracted by mini-css-extract-plugin
module.exports = {"main":"SelectBox_main__3R6qn","label":"SelectBox_label__3Xve8"};